import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Target, ShieldCheck, CalendarCheck } from 'lucide-react';
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const cardVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.22, 1, 0.36, 1]
    }
  }
};
export function CureSection() {
  const phases = [{
    number: '01',
    title: 'ATRACCIÓN DE PACIENTES CALIFICADOS',
    body: 'Segmentamos personas en tu área que buscan activamente tu especialidad y tienen capacidad de pago o seguro médico.',
    icon: Target
  }, {
    number: '02',
    title: 'AUTORIDAD CLÍNICA DIGITAL',
    body: 'Posicionamos tu clínica en el Top 3 de Google para tu especialidad. Construimos reseñas de 5 estrellas. Creamos contenido de autoridad médica que genera confianza antes de la cita.',
    icon: ShieldCheck
  }, {
    number: '03',
    title: 'SISTEMA ANTI NO-SHOW',
    body: 'Automatizamos recordatorios por WhatsApp, SMS y Email. Implementamos sistema de depósito previo. Creamos flujo de reactivación para pacientes inactivos.',
    icon: CalendarCheck
  }];
  return <section className="py-20 md:py-24 px-5 sm:px-6 md:px-8 bg-[#0a0a0a]" data-id="element-106">
      <div className="max-w-6xl mx-auto" data-id="element-107">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-12 md:mb-16 text-center" data-id="element-108">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-black text-white mb-4" data-id="element-109">
            La Cura —{' '}
            <span className="text-gold" data-id="element-110">Sistema A.C.E.™ Clínico</span>
          </h2>
          <div className="w-20 h-1 bg-emerald mx-auto rounded-full" data-id="element-111"></div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-112">
          {phases.map((phase, index) => {
          const Icon = phase.icon;
          return <motion.div key={index} variants={cardVariants} className="bg-carbon border border-white/5 p-6 md:p-8 rounded-xl flex flex-col items-center text-center hover:border-gold/30 transition-colors duration-300" data-id="element-113">
                <div className="w-16 h-16 rounded-full bg-emerald/10 flex items-center justify-center mb-6" data-id="element-114">
                  <Icon className="w-8 h-8 text-emerald" data-id="element-115" />
                </div>
                <div className="text-gold font-black text-lg md:text-xl mb-2 tracking-widest" data-id="element-116">
                  FASE {phase.number}
                </div>
                <h3 className="text-base md:text-lg font-bold text-white mb-4 md:h-14 flex items-center justify-center" data-id="element-117">
                  {phase.title}
                </h3>
                <p className="text-gray-400 text-sm md:text-base leading-relaxed" data-id="element-118">
                  {phase.body}
                </p>
              </motion.div>;
        })}
        </motion.div>
      </div>
    </section>;
}